export const CALENDAR_SETTING_TYPES = {
    GET_CALENDAR_EVENT_TITLE: "GET_CALENDAR_EVENT_TITLE",
    SAVE_CALENDAR_EVENT_TITLE: "SAVE_CALENDAR_EVENT_TITLE",
    INSERT_CALENDAR_EVENT_TITLE: "INSERT_CALENDAR_EVENT_TITLE",
    UPDATE_CALENDAR_EVENT_TITLE: "UPDATE_CALENDAR_EVENT_TITLE",
    DELETE_CALENDAR_EVENT_TITLE: "DELETE_CALENDAR_EVENT_TITLE",
}
